import { useEffect } from 'react';
import Text from '@sber-site/sbercraft-nova-kit/components/Text';
import Button from '@sber-site/sbercraft-nova-kit/components/Button';
import bem from 'bem-cn';
import { useStyles } from '../../../../LoaderContext';
import Icon from '@sber-site/sbercraft-nova-kit/components/Icon';
import { ReactComponent as CloseIcon } from '../../images/CloseIcon.svg';
import surverySuccess from '../../images/surverySuccess.svg';
import * as css from './Survery.css';
import addBlankTargets from '../../utils/addBlankTargets';

import { sendToAnalytics } from '../../analytics/web-analytics';

const cn = bem('retention');

export default function SurverySuccess({ surveryData, index, handleServeryShow }) {
    useStyles(css);
    useEffect(() => {
        sendToAnalytics('survey_success_show');
    }, []);

    return (
        <>
            <div className={cn('survery-closeIcon')()}>
                <Icon
                    onClick={() => {
                        sendToAnalytics('survey_close', 'cross');
                        handleServeryShow(false);
                    }}
                >
                    <CloseIcon />
                </Icon>
            </div>
            <div className={cn('survery-sentAnswerBlock')()}>
                <img src={surverySuccess} alt='surverySuccessIcon' className={cn('survery-imgSuccess')()} />
                <Text size='body2' bold={true} className={cn('survery-sentAnswerBlock_heading')()}>
                    {surveryData?.points?.[index]?.successHeader}
                </Text>
                <Text
                    html={addBlankTargets(surveryData?.points?.[index]?.successText)}
                    size='sm'
                    className={cn('survery-sentAnswerBlock_text')()}
                />
                <Button
                    type='tertiary'
                    size='sm'
                    onClick={() => {
                        sendToAnalytics('survey_close', 'button');
                        handleServeryShow(false);
                    }}
                >
                    Закрыть
                </Button>
            </div>
        </>
    );
}
